import "client-only";
import { UPGRADE_STEPS } from "@/lib/constants/maverick";
import { JOIN_FLOW_STEPS } from "@/lib/constants/maverick";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

export const useGetCurrentPageMaverick = ():
  | UPGRADE_STEPS
  | JOIN_FLOW_STEPS => {
  const pathname = usePathname();

  return useMemo(() => {
    if (pathname.includes('/upgrade/accessories')) {
      return UPGRADE_STEPS.ACCESSORIES;
    } else if (pathname.includes('/upgrade/upcycle')) {
      return UPGRADE_STEPS.UPCYCLE;
    } else if (pathname.includes(`/upgrade/options`)) {
      return UPGRADE_STEPS.OPTIONS;
    } else if (pathname.includes('/upgrade/order')) {
      return UPGRADE_STEPS.ORDER;
    } else if (pathname.includes('/upgrade/receipt')) {
      return UPGRADE_STEPS.RECEIPT;
    } else if (pathname.includes('/upgrade/ineligible')) {
      return UPGRADE_STEPS.INELIGIBLE;
    } else if (pathname.includes('/upgrade/signin')) {
      return UPGRADE_STEPS.SIGNIN;
    } else if (pathname.includes('upgrade')) {
      return UPGRADE_STEPS.UPGRADE;
    } else if (pathname.includes('bands')) {
      return JOIN_FLOW_STEPS.BANDS;
    } else if (pathname.includes('membership')) {
      return JOIN_FLOW_STEPS.MEMBERSHIP;
    } else if (pathname.includes('accessories')) {
      return JOIN_FLOW_STEPS.ACCESSORIES;
    } else if (pathname.includes('order')) {
      return JOIN_FLOW_STEPS.ORDER;
    } else if (pathname.includes('receipt')) {
      return JOIN_FLOW_STEPS.RECEIPT;
    } else if (pathname.includes('family')) {
      return JOIN_FLOW_STEPS.FAMILY;
    }
    return JOIN_FLOW_STEPS.JOIN;
  }, [pathname]);
};